// Google Ads conversion tracking.
// One label provided so far (a "Page view" conversion); reused for all key actions.
// When separate conversion actions exist in Google Ads, give each its own label here.
const LABELS = {
  signup: "AW-18397521427/Jd4PCOfH-eMcEJPMz8RE",
  first_scan: "AW-18397521427/Jd4PCOfH-eMcEJPMz8RE",
  redemption: "AW-18397521427/Jd4PCOfH-eMcEJPMz8RE",
};

export function trackConversion(action) {
  const sendTo = LABELS[action];
  if (!sendTo || typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "conversion", { send_to: sendTo });
  } catch (_) { /* no-op */ }
}

// Fire a conversion only once per browser (e.g. first receipt scanned).
export function trackConversionOnce(action, key) {
  const flag = `sliply_conv_${key}`;
  if (localStorage.getItem(flag)) return;
  localStorage.setItem(flag, "1");
  trackConversion(action);
}
